import { Navigate } from "react-router-dom";

import { SplashScreen } from "@/components/SplashScreen";
import { useOrganization } from "@/hooks/use-organization";
import { allEventsRouteDecision, OWN_EVENTS_ROUTE } from "@/utils/event-visibility";

type Props = {
  children: React.ReactNode;
};

// BON-885: All Events is for the organization's owner and its OWNER/ADMIN
// members. Anyone else is sent to My Events. The backend refuses them the
// organization's events either way; this keeps the page from being offered.
export function AllEventsGuard({ children }: Props) {
  const { currentOrganization, loading } = useOrganization();
  const decision = allEventsRouteDecision({ loading, organization: currentOrganization });

  if (decision === "wait") return <SplashScreen />;
  if (decision === "redirect") return <Navigate to={OWN_EVENTS_ROUTE} replace />;
  return <>{children}</>;
}
